export enum YearlyActivitiesEnum {
  YearlyDivident,
  ShareCertificate,
  ExportToExcelClick,
  FilterClick,
  SearchClick,
  // ExportToExcelClickWithdraw,
}
